import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ccdc1afe"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@4.47.0__ejs@3.1.10_handlebars@4.7.8_lodash@_2b6ea5449204c1f6ccb5ae9b9a82c939/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports